// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
// Auth
import { AuthGuard } from './core/auth';
import { BaseAdminComponent } from './views/theme/base-admin/base-admin.component';
import { LayoutUtilsService } from './core/_base/crud';
import { ActionEntityDialogComponent, ActionNotificationComponent, DeleteEntityDialogComponent } from './views/partials/content/crud';
import { ActivateAccountPageComponent } from './views/theme/activate-account-page/activate-account-page/activate-account-page.component';
import { PortletModule } from './views/partials/content/general/portlet/portlet.module';

const routes: Routes = [
	{
		path: 'activateaccount',
	  component:ActivateAccountPageComponent,
	},
	{ path: 'auth', loadChildren: () => import('app/views/pages/auth/auth.module').then(m => m.AuthModule) },
	//{path: '', redirectTo: '/homepage', pathMatch: 'full'},
	{
		path: '',
		component: BaseComponent,
		//canActivate: [AuthGuard],
		children: [
			{
				path: '',
				loadChildren: () => import('app/views/pages/pages.module').then(m => m.PagesModule)
			},
			// {
			// 	path: '',
			// 	loadChildren: () => import('app/views/pages/user-management/user-management.module').then(m => m.UserManagementModule)
			// },
			// {
			// 	path: 'error/403',
			// 	component: ErrorPageComponent,
			// 	data: {
			// 		type: 'error-v6',
			// 		code: 403,
			// 		title: '403... Access forbidden',
			// 		desc: 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator'
			// 	}
			// },
			// { path: 'error/:type', component: ErrorPageComponent },
		]
	},
	{
		path: '',
		component: BaseAdminComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: '',
				loadChildren: () => import('app/views/pages/admin-page/admin-page.module').then(m => m.AdminPageModule)
			},
			{
				path: 'admin/debt-summary',
				loadChildren: () => import('app/views/pages/admin-page/debt-summary/debt-summary.module').then(m => m.DebtSummaryModule)
			},
			{
				path: 'admin/debt-reminder-config',
				loadChildren: () => import('app/views/pages/admin-page/debt-reminder-config/debt-reminder-config.module').then(m => m.DebtReminderConfigModule)
			},
			{
				path: 'admin/unpaid-orders-management',
				loadChildren: () => import('app/views/pages/admin-page/unpaid-orders-management/unpaid-orders-management.module').then(m => m.UnpaidOrdersManagementModule)
			}
		]
	},
	{ path: '', redirectTo: '/homepage', pathMatch: 'full' },
	{ path: '**', redirectTo: '/homepage', pathMatch: 'full' }
];

@NgModule({
	declarations:[ActivateAccountPageComponent],
	imports: [
		RouterModule.forRoot(routes),
		PortletModule,
	],
	exports: [RouterModule],
	providers: [
		LayoutUtilsService
	],
	entryComponents:[
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		ActionEntityDialogComponent]
})
export class AppRoutingModule {
}
